import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import { styles } from '../WorkingHours.styles';
import { HolidaysCardProps } from '../HolidaysCardContainer';
import { formatDateRange } from '../utils/holidayDateUtils';
import { KonnectAnalytics } from 'KonnectAnalytics/konnectAnalytics';

const HolidaysCard = ({ siteNames, summaries, onOpen, onFetchHolidays }: HolidaysCardProps) => {
  const handleManageClick = () => {
    // bySite is keyed by site NAME, not site id.
    onOpen({ sites: siteNames });
    onFetchHolidays({ siteNames });
    KonnectAnalytics.productionHoursOpenHolidays({ site: siteNames.join(', ') });
  };

  return (
    <Box sx={styles.holidaysCard}>
      <Box sx={styles.holidaysHeader}>
        <Box sx={styles.holidaysIcon}>🗓</Box>
        <Typography sx={styles.holidaysTitle}>Holidays &amp; Days Off</Typography>
      </Box>

      <Typography sx={styles.holidaysDescription}>
        Define holidays and non-working days in advance. These days are excluded from
        production-hours calculations.
      </Typography>

      <Button
        variant="contained"
        size="small"
        onClick={handleManageClick}
        sx={styles.holidaysManageButton}>
        Manage holidays →
      </Button>

      {summaries.map(
        ({ siteName, summary }) =>
          summary.totalDays > 0 && (
            <Box key={siteName} sx={styles.holidaysSummary}>
              <Box sx={styles.holidaysSummaryRow}>
                <Box component="span" sx={styles.holidaysSummaryCount}>
                  {summary.totalDays}
                </Box>
                days off configured for <b>{siteName}</b>
              </Box>
              {summary.next && (
                <Box sx={styles.holidaysSummaryNext}>
                  Next: <b>{summary.next.name}</b> ·{' '}
                  {formatDateRange(summary.next.start, summary.next.end)}
                </Box>
              )}
            </Box>
          )
      )}
    </Box>
  );
};

export default HolidaysCard;
